module.exports = __webpack_public_path__ + "img/add-other-canceled-table-icon.8e8076a1.svg";